import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AnimationOutlinedIcon from "@mui/icons-material/AnimationOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import {
  db,
  collection,
  query,
  getDocs,
  orderBy,
  doc,
  getDoc,
  setDoc,
} from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import { use } from "i18next";
import AdminCheck from "./AdminCheck";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  const [admins, setAdmins] = useState([]);
  const [managers, setManagers] = useState([]);
  const [normalUsers, setNormalUsers] = useState([]);

  const [id, setId] = useState(null);
  const [newPosition, setNewPosition] = useState("user");
  const [secret, setSecret] = useState(null);
  const [alert, setAlert] = useState(null);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const openModal = (id) => {
    setId(id);
    handleOpen();
  };

  const changePosition = async () => {
    console.log("id", id);
    handleOpen();

    console.log("newPosition", newPosition);
    const docRef = doc(db, "secret", "code");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if (+secret === docSnap.data().code) {
        await setDoc(
          doc(db, "users", id),
          { position: newPosition },
          { merge: true }
        );
        setAlert(t("New position is set. Thank you."));
        setTimeout(() => {
          setAlert(null);
          getUsers();
          handleClose();
        }, 3000);
      } else {
        setAlert(t("Secret code is not matched. Try again."));
        setTimeout(() => {
          setAlert(null);
        }, 3000);
      }
    } else {
      setAlert(t("New position is set. Thank you."));
      setTimeout(() => {
        setAlert(null);
        getUsers();
        handleClose();
      }, 3000);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    setAdmins([]);
    setManagers([]);
    setNormalUsers([]);
    const q = query(collection(db, "users"), orderBy("created", "desc"));

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc2) => {
      if (doc2.data()?.position === "manager") {
        setManagers((old) =>
          old.concat({
            ...doc2.data(),
            id: doc2.id,
          })
        );
      } else if (doc2.data()?.position === "admin") {
        setAdmins((old) =>
          old.concat({
            ...doc2.data(),
            id: doc2.id,
          })
        );
      } else {
        setNormalUsers((old) =>
          old.concat({
            ...doc2.data(),
            id: doc2.id,
          })
        );
      }
    });
  };

  // console.log("admins === ", admins);
  // console.log("managers ====", managers);

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6" }}
          >
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  <AdminPanelSettingsOutlinedIcon
                    sx={{ position: "relative", top: "+3px" }}
                  />{" "}
                  {t("Elevated privileges of this user")}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  {t("Change the position of this user.")}
                  <FormControl fullWidth sx={{ mt: 3 }}>
                    <InputLabel id="demo-simple-select-label">
                      Position
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={newPosition}
                      label="Age"
                      onChange={(e) => setNewPosition(e.target.value)}
                    >
                      <MenuItem value={"user"}>{t("User")}</MenuItem>
                      <MenuItem value={"manager"}>{t("Manager")}</MenuItem>
                      <MenuItem value={"admin"}>{t("Administrator")}</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    variant="filled"
                    label={t("Enter a secret code to proceed")}
                    sx={{ width: 1, mt: 2 }}
                    inputProps={{ maxLength: 6 }}
                    value={secret}
                    onChange={(e) => setSecret(e.target.value)}
                  />
                </Typography>
                <Box
                  sx={{ py: 1, pt: 2, textAlign: "center", color: "#0d47a1" }}
                >
                  {alert}
                </Box>
                <button
                  onClick={changePosition}
                  className="custom_btn"
                  style={{ marginTop: "20px" }}
                >
                  {t("Submit")}
                </button>
              </Box>
            </Modal>
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px" }}>{t("Manage Admins")}</Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  Manage Admins
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "20px",
                }}
              >
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    py: 2,
                    fontSize: "15px",
                  }}
                >
                  {t("Number of Managers")}
                  <Box sx={{ fontSize: "19px", pt: 2 }}>{managers?.length}</Box>
                  {/* <Box sx={{ color: "gray", fontSize: "13px", pt: 3 }}>
                    Just Now
                  </Box> */}
                </Box>
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 2,
                    fontSize: "15px",
                  }}
                >
                  {t("Number Of Admins")}
                  <Box sx={{ fontSize: "19px", pt: 2 }}>{admins?.length}</Box>
                </Box>
                {/* <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 2,
                  }}
                >
                  Number of Admins
                  <Box sx={{ fontSize: "19px", pt: 2 }}>{orders?.length}</Box>
                </Box> */}
                {/* <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 2,
                  }}
                >
                  Revenue<Box sx={{ fontSize: "19px", pt: 2 }}>$12</Box>
                </Box> */}
              </Box>
              <Grid container>
                <Grid item md={6} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      mr: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                      minHeight: "400px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>{t("Admins")}</Box>
                      {/* <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        Setting
                      </Box> */}
                    </Box>
                    <Box
                      sx={{
                        py: 2,
                        px: 4,
                        minHeight: "300px",
                      }}
                    >
                      {admins?.map((user, idx) => {
                        console.log("user.id", user);
                        return (
                          <Box
                            sx={{
                              py: 1,
                              pt: 1,
                              borderBottom: "1px solid lightgray",
                            }}
                          >
                            <Box>
                              <Box
                                style={{
                                  cursor: "pointer",
                                  lineHeight: "2.0em",
                                }}
                              >
                                <AnimationOutlinedIcon
                                  sx={{
                                    position: "relative",
                                    top: "+3px",
                                    fontSize: "15px",
                                    color: "#00897b",
                                  }}
                                  onClick={() => openModal(user.id)}
                                />
                                <span style={{ textDecoration: "none" }}>
                                  &nbsp;
                                </span>
                                <span
                                  className="pink_link"
                                  onClick={() => openModal(user.id)}
                                >
                                  {user.firstname} {user.lastname}
                                </span>
                                <Box className="pink_link">
                                  <HashLink to={"/admin/user/" + user.id}>
                                    {t("User Info Page")}
                                  </HashLink>
                                </Box>
                              </Box>
                              {t("Member Since")}:&nbsp;
                              {user?.created?.toDate().getFullYear() +
                                "/" +
                                String(
                                  user?.created?.toDate().getMonth()
                                ).padStart(2, "0") +
                                "/" +
                                String(
                                  user?.created?.toDate().getDate()
                                ).padStart(2, "0") +
                                " " +
                                String(
                                  user?.created?.toDate().getHours()
                                ).padStart(2, "0") +
                                ":" +
                                String(
                                  user?.created?.toDate().getMinutes()
                                ).padStart(2, "0")}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      ml: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                      minHeight: "400px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>{t("Managers")}</Box>
                      {/* <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        Setting
                      </Box> */}
                    </Box>
                    <Box sx={{ py: 2, px: 4 }}>
                      {managers?.map((user, idx) => {
                        console.log("user.id", user);
                        return (
                          <Box
                            sx={{
                              py: 1,
                              pt: 1,
                              borderBottom: "1px solid lightgray",
                              lineHeight: "2.0em",
                            }}
                          >
                            <Box>
                              <Box sx={{ cursor: "pointer" }}>
                                <AssignmentIndOutlinedIcon
                                  onClick={() => openModal(user.id)}
                                  sx={{
                                    position: "relative",
                                    top: "+3px",
                                    fontSize: "15px",
                                    color: "#00897b",
                                  }}
                                />{" "}
                                <span
                                  onClick={() => openModal(user.id)}
                                  className="pink_link"
                                >
                                  {user.firstname} {user.lastname}
                                </span>
                                <Box className="pink_link">
                                  <HashLink to={"/admin/user/" + user.id}>
                                    {t("User Info Page")}
                                  </HashLink>
                                </Box>
                              </Box>
                              {t("Member Since")}:&nbsp;
                              {user?.created?.toDate().getFullYear() +
                                "/" +
                                String(
                                  user?.created?.toDate().getMonth()
                                ).padStart(2, "0") +
                                "/" +
                                String(
                                  user?.created?.toDate().getDate()
                                ).padStart(2, "0") +
                                " " +
                                String(
                                  user?.created?.toDate().getHours()
                                ).padStart(2, "0") +
                                ":" +
                                String(
                                  user?.created?.toDate().getMinutes()
                                ).padStart(2, "0")}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
